import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { Button, Form } from "reactstrap";
import classNames from "classnames";
import authenticationService from "../../services/authenticationService";
import SikkaInput from "../common/SikkaInput";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

const PasswordResetForm = ({ layout, hasLabel }) => {
  const { register, handleSubmit, watch, errors } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const history = useHistory();

  const emailID = sessionStorage.getItem("SaveEmailID");

  const handleResetPasswordHandler = (values) => {
    if (emailID) {
      let body = {
        email: `${emailID}`,
        password: `${values.password}`,
        code: `${values.otp}`,
      };
      authenticationService
        .forgetPassword("new_password", body)
        .then((res) => {
          toast.success(`${res.data.message}`);
          toast.success("Login with your new password");
          sessionStorage.removeItem("SaveEmailID");
          // Direct navigation instead of withRedirect to avoid 404 flash
          setTimeout(() => {
            history.push(`${process.env.PUBLIC_URL}/authentication/login`);
          }, 1500);
        })
        .catch((error) => {
        if (error.response.data?.attempts === 5 || error.response.data?.errorCode === "LOCKED") {
             toast.error("Too many attempts. Redirecting to login...");
           setTimeout(() => {
              history.push(`${process.env.PUBLIC_URL}/authentication/login`);
            }, 1000);
             return;
           }   
          const resMessage =
            (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
          toast.error(resMessage);
        });
    } else {
      toast.warn("Something went wrong on our side!");
    }
  };


  return (
    <Form
      style={{
        minWidth: "300px",
        maxWidth: "600px",
      }}
      className={classNames("mt-2", { "text-left": hasLabel })}
      onSubmit={handleSubmit(handleResetPasswordHandler)}
    >
      <SikkaInput
        parentClassName="mb-0"
        placeholder={!hasLabel ? "Enter A OTP" : ""}
        label="Enter A OTP"
        name="otp"
        type="number"
        id="otp"
        innerRef={register({
          required: "You must enter the OPT sent to your email ID",
        })}
        errors={errors}
      />

      <div style={{ position: "relative" }}>
        <SikkaInput
          parentClassName="mb-0"
          type={showPassword ? "text" : "password"}
          name="password"
          placeholder="New Password"
          id="password"
          innerRef={register({
            required: "You must specify a password",
            minLength: {
              value: 8,
              message: "Password must have at least 8 characters",
            },
            pattern: {
              value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])(?=.{8,})/g,
              message:
                "Password should contain at least 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character and be at least 8 characters long.",
            },
          })}
          errors={errors}
        />
        <i
          className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
          style={{
            position: "absolute",
            right: "12px",
            top: "32px",
            cursor: "pointer",
            color: "#9c9797ff",
            fontSize: "16px",
            zIndex: 10
          }}
          onClick={() => setShowPassword(!showPassword)}
        ></i>
      </div>

      <div style={{ position: "relative" }}>
        <SikkaInput
          parentClassName="mb-0"
          type={showConfirmPassword ? "text" : "password"}
          name="confirmPassword"
          placeholder="Confirm Password"
          id="confirmPassword"
          innerRef={register({
            required: "Confirm Password field is required",
            validate: (value) => value === watch("password") || "The password do not match",
          })}
          errors={errors}
        />
        <i
         className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"}`}
          style={{
            position: "absolute",
            right: "12px",
            top: "32px",
            cursor: "pointer",
            color: "#9c9797ff",
            fontSize: "16px",
            zIndex: 10
          }}
          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
        ></i>
      </div>

      <Button type="submit" color="primary" block className="mt-3">
        Reset password
      </Button>
    </Form>
  );
};

PasswordResetForm.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool,
};

PasswordResetForm.defaultProps = { layout: "basic", hasLabel: false };

export default PasswordResetForm;